<template>
  <router-view></router-view>
</template>

<style lang="scss">
  @import "~styles/global.scss";
</style>

<script>
  export default {
    data () {
      return {
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/App.vue